import { useSyncExternalStore } from 'react';

export interface NewProjectRequest {
  chatId?: string;
  chatTitle?: string;
  name?: string;
  returnFocus?: HTMLElement | null;
}

let request: (NewProjectRequest & { route: string; key: number }) | null = null;
let opened = 0;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((listener) => listener());

export function openNewProject(next: NewProjectRequest = {}) {
  request = {
    returnFocus: document.activeElement instanceof HTMLElement ? document.activeElement : null,
    ...next,
    route: location.hash,
    key: ++opened,
  };
  emit();
}
export function closeNewProject() {
  request = null;
  emit();
}
export const isNewProjectOpen = () => request !== null;
export function useNewProjectRequest() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => request,
  );
}
